
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import LeaderboardNavigator from "@/components/cards/LeaderboardNavigator.vue";

export default defineComponent({
  name: "Leaderboard",
  components: {
    LeaderboardNavigator
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Leaderboard");
    });
  }
});
